import { PaginatedSearchRequest, BuyerInvite } from './../types';
import { request } from 'utils/ajax';
import { PaginationResult } from 'types';
import { toQueryString } from 'utils/url';

export interface BuyerInvitationSearchOptions {
    includeAccepted: boolean;
}

export function getBuyerInvitations(
    req: PaginatedSearchRequest,
    options: BuyerInvitationSearchOptions
): Promise<PaginationResult<BuyerInvite>> {
    return request(`api/buyerinvitation`, { query: { ...req, ...options } }).then((x) => x.json());
}

export function getBuyerInvitationsExportUrl(req: PaginatedSearchRequest, options: BuyerInvitationSearchOptions) {
    return `api/buyerinvitation/excel?${toQueryString({ ...req, ...options })}`;
}
